import { useSelector } from 'react-redux'

import { selectUserProfile } from '../slices/userSlice'
import { UserDocument } from '../../lib/db/db.types'
import { updateUserProfile } from '../../lib/db'
import { useAuth } from './useAuth'
import { useCallback } from 'react'

export const useUserProfile = () => {
  const { authUser } = useAuth()
  const profile = useSelector(selectUserProfile)

  const updateProfile = useCallback(
    (updates: Partial<UserDocument>) => {
      if (!authUser) return

      updateUserProfile({
        userId: authUser.id,
        updates,
      })
    },
    [authUser],
  )

  return { profile, updateProfile }
}
